//
// GENERATED by Kilua RPC
//
package rpc

import web.http.Request
import dev.kilua.rpc.RpcAgent
import kotlinx.serialization.modules.SerializersModule
import kotlin.Boolean
import kotlin.String
import kotlin.collections.List
import models.Discussion
import models.GameResultSummary
import models.Note
import models.UserSession

class AppServiceImpl(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend Request.() -> Unit)? = null) : AppService, RpcAgent<AppService>(AppServiceManager, serializersModules, requestFilter) {
    override suspend fun getCurrentUser() = call(AppService::getCurrentUser)
    override suspend fun getNotes() = call(AppService::getNotes)
    override suspend fun saveNote(title: String, content: String) = call(AppService::saveNote, title, content)
    override suspend fun deleteNote(noteId: String) = call(AppService::deleteNote, noteId)
    override suspend fun getDiscussions() = call(AppService::getDiscussions)
    override suspend fun postDiscussion(content: String) = call(AppService::postDiscussion, content)
    override suspend fun getGameHistory() = call(AppService::getGameHistory)
}
